import { useEffect, useState } from 'react';
import { isCurrentUserAdmin } from '../services/profile';

/**
 * Statut admin de l'utilisateur courant. Sert au GATING UX (afficher/masquer l'entrée admin).
 * Ce n'est PAS une frontière de sécurité : la protection réelle des données admin vit côté
 * serveur (RLS + edge function service-role qui revérifie le rôle avant de renvoyer les KPI).
 */
export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    isCurrentUserAdmin()
      .then((value) => active && setIsAdmin(value))
      .catch(() => active && setIsAdmin(false))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { isAdmin, loading };
}
